<template>
	<div class="commit2" id="totop">
			<div class="title title3">
				<span class="left1"></span>
				<span class="left2"></span>
				<span class="left3"></span>
				<span class="middle">请填写投稿信息</span>
				<span class="right1"></span>
				<span class="right2"></span>
				<span class="right3"></span>
			</div>
			<el-form ref="form" :model="form" label-width="80px" class="formCommit">
			  <el-form-item label="作品名称">
			    <el-input v-model="form.title" class="inputName"></el-input>
			    <span class="rules"><img src="../assets/img/xing.png"/><span v-show='Istitle'>作品名字不能超出20个字符</span><span v-show='IstitleNull'>作品名字不能不能为空</span></span>
			  </el-form-item>
			  <el-form-item label="游戏定位">
			    <el-select v-model="form.location" placeholder="请选择游戏定位" class="inputName">
			      <el-option label="儿童游戏" value="1"></el-option>
			      <el-option label="家庭游戏" value="2"></el-option>
			      <el-option label="进阶游戏" value="3"></el-option>
			      <el-option label="重度游戏" value="4"></el-option>
			    </el-select>
			    <span class="rules"><img src="../assets/img/xing.png"/><span v-show='Islocation'>游戏定位不能为空</span></span>
			  </el-form-item>
			  <el-form-item label="游戏分类">
			    <el-select v-model="form.type" placeholder="请选择游戏分类" class="inputName">
			      <el-option label="抽象游戏" value="1"></el-option>
			      <el-option label="策略游戏" value="2"></el-option>
			      <el-option label="卡牌游戏" value="3"></el-option>
			      <el-option label="聚会游戏" value="4"></el-option>
			      <el-option label="骰子游戏" value="5"></el-option>
			      <el-option label="合作游戏" value="6"></el-option>
			      <el-option label="主题游戏" value="7"></el-option>
			      <el-option label="其他游戏" value="8"></el-option>
			    </el-select>
			    <span class="rules"><img src="../assets/img/xing.png"/><span v-show="Istype">游戏分类不能为空</span></span>
			  </el-form-item>
			  <el-form-item label="游戏时长">
			    <el-select v-model="form.time_game" placeholder="请选择游戏时长" class="inputName">
			      <el-option label="0-15分钟" value="1"></el-option>
			      <el-option label="16-30分钟" value="2"></el-option>
			      <el-option label="31-60分钟" value="3"></el-option>
			      <el-option label="61-120分钟" value="4"></el-option>
			      <el-option label="120分钟以上" value="5"></el-option>
			    </el-select>
			    <span class="rules"><img src="../assets/img/xing.png"/><span v-show="Istime">游戏时长不能为空</span></span>
			  </el-form-item>
			  <el-form-item label="适合年龄">
			    <el-select v-model="form.age" placeholder="请选择合适年龄" class="inputName">
			      <el-option label="4岁以上" value="1"></el-option>
			      <el-option label="6岁以上" value="2"></el-option>
			      <el-option label="10岁以上" value="3"></el-option>
			      <el-option label="14岁以上" value="4"></el-option>
			      <el-option label="18岁以上" value="5"></el-option>
			    </el-select>
			    <span class="rules"><img src="../assets/img/xing.png"/><span v-show="Isage">适合年龄不能为空</span></span>
			  </el-form-item>
			  <el-form-item label="最小游戏人数">
			  	<el-input v-model="form.players_down" class="inputName1"></el-input>人
			  	<span class="f16">最大游戏人数</span>
			    <el-input v-model="form.players_up" class="inputName1"></el-input>人
			    <span class="rules"><img src="../assets/img/xing.png"/><span v-show='Isplayers'>请重新填写游戏人数</span><span v-show='zplayers'>游戏人数必须为整数</span></span>
			  </el-form-item>
			</el-form>
			<el-upload class="upload-demo" :action="uploadHost" :file-list="fileList" :on-success="handleSuccess" :data="ossParams" :on-change="handleChange" :beforeUpload="beforeAvatarUpload" :on-remove="handleRemove" :limit=1>
  				<el-button type="primary" round>说明文档上传</el-button><span class="rules"><img src="../assets/img/xing.png"/></span><span class="up-text">（上传文件大小上限20mb）</span>
			</el-upload>
			<p class="detail">请上传详细规则说明文档，内容包括完整的配件数量、游戏设置、流程、结算等规则。此外若有已完成的游戏版图、卡牌、插画、说明图示、测试记录等测试材料，请以压缩包的形式一同打包上传。完成度越高的作品，将越有可能通过初审！</p>
			<p class="introduction"><span class="introductionSpan">简短说明  <img src="../assets/img/xing.png"/></span>请对投稿作品进行简单介绍，大致描述游戏的主题、玩法、特色等内容，以便审核人员快速了解作品并进行分类筛选。</p>
				<textarea name="" rows="20" cols="110" class="shuoming" v-model="form.introduction"></textarea>
				<div class="con-tips"><span class="rules"><span v-show='Isintro'>简短说明不能为空</span></span></div>
				<textarea name="" rows="20" cols="110" class="tiaoyue" readonly="readonly">
					  	                        游卡桌游设计平台投稿条款
					
“游卡桌游设计投稿平台”是一个游卡桌游向原创桌游设计师长期征集设计稿件的平台。在您投稿之前，请认真阅读下述条款。在您确认已理解并接受本协议后，点击“同意”按钮并继续投稿。

一、投稿要求
1、投稿作品内容必须符合国家法律法规，不违背善良道德风俗，并不得与任何宗教、民族、信仰发生冲突；作品中不得存在广告信息和负面消息（包括色情、暴力等）。
2、游卡桌游设计投稿平台要求所有设计作品均为原创，您必须保证向该平台投稿的作品属于原创，且未被出版。如有剽窃、抄袭，或在已经在其他平台发布，一经发现，本平台有权删除作者账号及其发表的任何内容。游卡桌游不为此向您承担违约责任或其他法律责任，包括不承担因侵权指控不成立而给您带来损害的赔偿责任。

二、投稿方式
1、在稿件初审阶段，作品将以电子文档的方式递交；在稿件复审阶段，作品将以电子文档或者寄送实物样品的方式递交。
2、投稿后的作品可以视审核状态进行修改，具体修改权限请参阅投稿管理页面说明。
3、作品稿件提供至游卡桌游后，其物品（电子稿或实物）所有权将归游卡桌游所有，但其知识产权不因此发生转让。从作品稿件安全性角度出发，游卡桌游提醒并强烈建议投稿作者务必妥善保留原稿。

三、稿件录用
通过复审的投稿作品，将由游卡桌游工作人员联系投稿者沟通协商录用出版的相关事宜，包括产品化方案、版税分成方式等内容，双方达成书面协议后，才会正式录用准备出版。
在投稿作品是否通过复审被确定前，不建议投稿者自行或授权第三方出版投稿作品，否则投稿者将可能丧失前述合作机会。

四、知识产权归属
1、投稿者独立自主完成的规则、美术、文案、工艺等设计，其知识产权归投稿者所有。
2、投稿者在游卡桌游指导、协助下完成的规则、美术、文案、工艺等设计，其知识产权归双方共同所有。
3、由游卡桌游提供的美术制作、产品化方案、制作工艺等设计，其知识产权归游卡桌游所有
4、投稿者同意游卡桌游有权为评审需要就投稿作品以复制、修改等必要的方式进行使用。尽管如此，为保护投稿者知识产权，游卡桌游承诺对所有投稿资料进行严格保密，且不会在投稿者双方达成书面协议前擅自出版。若投稿通过最终审核，将与作者签订授权协议后进行出版，否则不会对外公布任何投稿内容。

五、隐私保护
为保证后续联系沟通，本平台需要投稿者提供包括姓名、笔名、国籍、电子邮箱、通讯地址、联系电话等个人信息。投稿者应保证所提供的信息真实有效。游卡桌游承诺采取足够措施保护投稿者个人信息不被泄露，并承诺仅在进行下述业务时使用参赛设计师个人信息：
1）发送平台相关通知
2）基于投稿作品、复审资料需要与投稿者沟通
3）基于投稿作品商业合作需要与投稿者沟通
4）与本平台相关的其他事项
但当出现以下情况时，游卡桌游无需另行征得投稿者同意，而向第三方提供投稿者个人信息：
1）依据中国法律、法规规定向中国政府部门提供；
2）当投稿者的人身安全或财产安全受到威胁，暂时无法与投稿者取得联络时；
3）若投稿者书面同意向指定国家或地区政府或其他第三方团体使用其提交给游卡桌游的个人信息时，在暂时无法与投稿者取得联络的情况下，游卡桌游可以向该方提供投稿者的资料。

六、其他
1、本协议未尽事宜，以游卡通行证注册协议为准；本协议如与游卡通行证注册协议，或者双方另行达成的书面协议冲突的，则优先顺序为（1）双方另行达成的书面协议；（2）本协议；（3）游卡通行证注册协议。
2、本协议项下“出版”特指将投稿作品作为桌游产品进行规模化生产，并公开销售。
3、游卡桌游在法律范围内对本协议对拥有最终解释权。

				</textarea>
				<el-radio-group v-model="form.is_agree" class="agreement">
			      <el-radio label="1">同意此稿条约</el-radio>
			      <el-radio label="0">不同意此稿条约</el-radio>
			   </el-radio-group>
			    <el-button type="primary" round class="commitFirst" @click="firstPost"  :disabled='form.is_agree==0'>投递初稿</el-button>
			    
		</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data(){
			return {
				Isflow:true,
				form: {
		          title: '',
		          location: '',
		          type:'',
		          age:'',
		          time_game:'',
		          players_down:'',
		          players_up:'',
		          introduction:'',
		          is_agree:'1',
		          first_checkfile:''
		      },
		       fileList:[],
		       uploadHost:process.env.BASE_URL+'/oss/get-sign?type=2',
		       ossParams:{
		       	 key: '', // key后面有用，先默认设空字符串
  				 success_action_status: '200', // 默认200
		       },
		       picOSS:false,
		       dir:'',
		       Istitle:false,
		       Islocation:false,
		       Istype:false,
		       Istime:false,
		       Isage:false,
		       Isplayers:false,
		       zplayers:false,
		       IstitleNull:false,
		       login:false,
		       Isintro:false
			}
		},
		methods:{
			init() {
			  axios({
					method:'post',
					url:process.env.BASE_URL + '/login/is-login',
					withCredentials:true,
			  }).then(res =>{
			  	if(res.data.code == 10000){
			  		this.login = true
			  	} else {this.login =false}
			  })

              axios({
					method:'get',
					url:process.env.BASE_URL + '/user/isWriteInfo',
					withCredentials:true,
			  }).then(res =>{
			  	if(res.data.code == 10000){
			  		if(res.data.data.status == 0){
                       this.$confirm('个人资料还未填写，请先去填写个人资料', '提示', {
				          confirmButtonText: '去填写',
				          showCancelButton:false,
				          showClose:false,
				          closeOnClickModal:false,
				          type: 'warning'
				        }).then(() => {
				          this.$router.push({path:'/person/information'})
				        }).catch(() => {
				                  
				        });
			  		}
			  	} else {
                   this.$message(res.data.message)
			  	}
			  })


			},
			handleChange(file, fileList){
				 this.fileList = fileList.slice(-1)
			},
		    // 上传前对文件的大小的判断
		    beforeAvatarUpload (file) {
		      const isLt2M = file.size / 1024 / 1024 < 20
		      if (!isLt2M) {
		        this.$confirm('上传说明文档大小不能超过20MB，请删除后重新上传！', '提示', {
		          confirmButtonText: '确定',
		          showCancelButton:false,
		          type: 'warning'
		        }).then(() => {
		          
		        }).catch(() => {
		                  
		        });
		      }
		      return isLt2M
		    },
		    handleRemove(file, fileList) {
		        this.dir = ''
		    },
			firstPost(){
//				axios({
//					method:'post',
//					url:process.env.BASE_URL + '/login/is-login',
//					withCredentials:true,
//				})
//				.then(res =>{
//					if(res.data.code == 10000){
						if(this.form.title.length < 1){
							this.IstitleNull = true; 
							this.Istitle = false;
							window.scrollTo(0,250);
							return;
						}else if(this.form.title.length > 20){
							this.Istitle = true; 
							this.IstitleNull = false;
							window.scrollTo(0,250);
							return;
						}else{
							this.Istitle = false; 
							this.IstitleNull = false;
						}
						if(this.form.location.length < 1){
							this.Islocation = true
							window.scrollTo(0,250);
							return;
						}else{
							this.Islocation = false;
						}
						if(this.form.type.length < 1){
							this.Istype = true
							window.scrollTo(0,250);
							return;
						}else{
							this.Istype = false
						}
						if(this.form.time_game.length < 1){
							this.Istime = true
							window.scrollTo(0,250);
							return;
						}else{
							this.Istime = false
						}
                        if(this.form.age.length < 1){
							this.Isage = true
							window.scrollTo(0,250);
							return;
						}else{
							this.Isage = false
						}
						var regBox = {
							ageReg:  /^\+?[1-9][0-9]*$/
						}
						var downNum = this.form.players_down
						var upNum = this.form.players_up
						var dflag = regBox.ageReg.test(downNum);
						var uflag = regBox.ageReg.test(upNum);
						var ubig = this.form.players_up-this.form.players_down
						if(ubig<0 || this.form.players_down<1 || this.form.players_down<1){
							this.Isplayers = true
							this.zplayers = false
							window.scrollTo(0,250);
							return;
						}else if(!(dflag || uflag)){
							this.Isplayers = false
							this.zplayers = true
							window.scrollTo(0,250);
							return;
						}else{
							this.Isplayers = false
							this.zplayers = false
						}

						if(this.form.introduction.length < 1){
							this.Isintro = true
							window.scrollTo(0,800);
							return;
						}else{
							this.Isintro = false
						}

						if (this.picOSS == true) {
							var form = new FormData
							form.append('title',this.form.title)
							form.append('location',this.form.location)
							form.append('type',this.form.type)
							form.append('age',this.form.age)
							form.append('time_game',this.form.time_game)
							form.append('players_down',this.form.players_down)
							form.append('players_up',this.form.players_up)
							form.append('introduction',this.form.introduction)
							form.append('is_agree',this.form.is_agree)
							form.append('first_checkfile',this.dir)
							axios({
								method:'post',
								url:process.env.BASE_URL+'/apply/first-commit',
								data:form,
								withCredentials:true
							})
							.then(res => {
								if (res.data.code == 10000) {
                                    this.$confirm('投稿成功', '提示', {
							          confirmButtonText: '确定',
							          showCancelButton:false,
							          type: 'success'
							        }).then(() => {
							          this.$router.push({path:'/person/manage'})
							        }).catch(() => {
							                  
							        });
								}
								else{
                                    // this.$confirm('投稿信息填写错误，请检查无误后提交', '提示', {
                                    this.$confirm(res.data.message, '提示', {
							          confirmButtonText: '确定',
							          showCancelButton:false,
							          type: 'warning'
							        }).then(() => {
							          // this.$router.push({path:'/person/information'})
							          window.scrollTo(0,250);
							        }).catch(() => {
							                  
							        });

								}
							})
						} else{
							this.$message.error('说明文档为空或说明文档大小超过限制，请重新上传！')
							window.scrollTo(0,400);
						}
//					} else{
//						this.$message(res.data.message)
//					}
//				})
				
			},
			handleSuccess(res, file) {
			  this.dir = res.dir + file.name
			  var form3 = new FormData
			  form3.append('name',file.name)
			  form3.append('key',res.dir+'${filename}')
			  form3.append('policy',res.policy)
			  form3.append('OSSAccessKeyId',res.accessid)
			  form3.append('success_action_status','200')
			  form3.append('signature',res.signature)
			  form3.append('file',file.raw)
			  axios({
			  	method:'post',
			  	url:res.host,
			  	data:form3,
			  	withCredentials:false
			  })
			  .then(res =>{
			  	 this.picOSS = true
			  })
			},
		},
		created(){
			this.init()
		}
	}
</script>

<style scoped>
	.commit1 button, .commitFirst{
		width: 322px;
		height: 86px;
		font-size: 33px;
		display: block;
		margin: 80px auto;
	}
	.title{
		width: 400px;
		margin: 0 auto;
		color: #F48A65;
		padding-bottom: 30px;
		text-align: center;
	}
	.left1, .left2, .left3, .right1, .right2, .right3{
		border-top:2px solid #F48A65;
		border-left: 2px solid #F48A65;
	}
	
	.commit2{
		padding-top: 290px;
		width: 1000px;
		margin: 0 auto;
	}
	.formCommit{
		padding-left: 78px; margin: 15px 0 60px;
	}
	.title3{
		color: black;
	}
	.left1, .left2, .left3, .right1, .right2, .right3{
		border-top:2px solid gray;
		border-left: 2px solid gray;
	}
	.inputName{
		width: 450px;
	}
	.inputName1{
		width: 150px;
		padding-right: 5px;
	}
	.rules img{
		padding-left: 20px;
		padding-right: 20px;
	}
	.rules{
		color: #F48A65;
	}
	.commit2 .detail{
		color: #6ab3ff; margin-left: 95px; width: 805px; font-size: 14px; line-height: 22px;
	}
	.f16{ font-size: 16px; padding: 0 10px 0 23px; color: #606266;}
	.commit2 .shuoming, .tiaoyue{
		width: 781px;
		height: 298px;
		border: 1px solid gray;
		border-radius: 15px;
		margin-bottom: 16px;
		outline: none;
		margin-left: 95px;
		padding: 10px;
	}
	.commit2 .introduction{
		color: #adacac; margin-left: 95px; font-size: 14px; margin-top: 50px;
	}
	.introduction .introductionSpan{
		font-size: 20px;
		color: #434242;
	}
	.commit2 .tiaoyue{
		overflow: auto;
		padding: 20px;
		width: 760px; line-height: 20px;
	}
	.agreement{
		text-align: center;
		margin: 0px auto;
		width: 1000px;
	}	
	.upload-demo{
		width: 730px; margin-left: 95px;
	}
	.up-text{
		color: #F48A65;
		font-size: 14px;
	}
	.con-tips{ font-size: 14px; padding: 0 0 15px 96px;}
</style>


// WEBPACK FOOTER //
// src/views/commitdetail.vue